/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_Birthday_Others_OtherInputs */

const fr_calendar_birthday_others_other = /** @type {(inputs: Calendar_Birthday_Others_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`et ${i?.count} autres`)
};

/**

* @param {Calendar_Birthday_Others_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_others_other = /** @type {((inputs: Calendar_Birthday_Others_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_Others_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_others_other(inputs)
});